import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AdminReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) toast.error("No reset token in link");
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== confirm) { toast.error("Passwords don't match"); return; }
    if (pwd.length < 6) { toast.error("Min 6 characters"); return; }
    setLoading(true);
    try {
      await api.post("/admin/reset", { token, new_password: pwd });
      toast.success("Password reset — please sign in");
      nav("/admin");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[var(--navy)] grid place-items-center p-6" data-testid="admin-reset">
      <form onSubmit={submit} className="bg-[var(--bone)] p-10 rounded-sm w-full max-w-md">
        <div className="font-serif-display text-3xl text-[var(--navy)]">Set New Password</div>
        <div className="font-mono-ui text-[10px] tracking-[0.25em] text-[var(--ink-soft)] mt-1">MIN 6 CHARACTERS</div>
        <div className="space-y-3 mt-5">
          <input type="password" placeholder="New password" value={pwd} onChange={(e)=>setPwd(e.target.value)} className="input-field" data-testid="reset-new"/>
          <input type="password" placeholder="Confirm password" value={confirm} onChange={(e)=>setConfirm(e.target.value)} className="input-field" data-testid="reset-confirm"/>
        </div>
        <button disabled={loading} className="btn-primary w-full justify-center mt-5" data-testid="reset-submit">{loading ? "Saving…" : "Save Password"}</button>
        <Link to="/admin" className="block text-center mt-4 font-mono-ui text-[10px] tracking-[0.25em] text-[var(--ink-soft)]">← BACK TO SIGN IN</Link>
      </form>
    </div>
  );
}
